// Backend'den gelen hata formatı:
// {
//   "message": "Unauthorized: Only SUPERADMIN can change user roles",
//   "error": "Bad Request", 
//   "statusCode": 400
// }

export interface BackendError {
  message: string;
  error: string;
  statusCode: number;
}

export interface ErrorDisplayOptions {
  defaultMessage?: string;
  showStatusCode?: boolean;
}

/**
 * Backend'den gelen hatayı işleyip kullanıcıya gösterilecek mesajı döndürür
 * @param error - Catch bloğundan gelen hata
 * @param options - Hata gösterim seçenekleri
 * @returns Kullanıcıya gösterilecek hata mesajı
 */
export const getErrorMessage = (error: any, options: ErrorDisplayOptions = {}): string => {
  const { defaultMessage = 'Bir hata oluştu. Lütfen tekrar deneyin.', showStatusCode = false } = options;

  try {
    // Error string olarak gelmişse parse etmeye çalış
    if (typeof error === 'string') {
      const parsedError = JSON.parse(error);
      if (parsedError.message) {
        return showStatusCode && parsedError.statusCode 
          ? `${parsedError.message} (${parsedError.statusCode})`
          : parsedError.message;
      }
    }

    // Error object olarak gelmişse
    if (error && typeof error === 'object') {
      // Backend error formatı
      if (error.message && error.statusCode) {
        return showStatusCode 
          ? `${error.message} (${error.statusCode})`
          : error.message;
      }

      // Error.message varsa onu kullan
      if (error.message) {
        return error.message;
      }

      // Error.error varsa onu kullan
      if (error.error) {
        return error.error;
      }
    }

    // Hiçbiri yoksa default mesajı döndür
    return defaultMessage;
  } catch (parseError) {
    // JSON parse hatası durumunda default mesajı döndür
    return defaultMessage;
  }
};

/**
 * Status code'a göre hata türünü belirler
 * @param statusCode - HTTP status code
 * @returns Hata türü
 */
export const getErrorType = (statusCode: number): 'error' | 'warning' | 'info' => {
  if (statusCode >= 400 && statusCode < 500) {
    return 'error';
  } else if (statusCode >= 500) {
    return 'error';
  } else if (statusCode >= 300 && statusCode < 400) {
    return 'warning';
  } else {
    return 'info';
  }
};

/**
 * Status code'a göre hata açıklaması döndürür
 * @param statusCode - HTTP status code
 * @returns Hata açıklaması
 */
export const getStatusCodeDescription = (statusCode: number): string => {
  const descriptions: { [key: number]: string } = {
    400: 'Geçersiz İstek',
    401: 'Yetkisiz Erişim',
    403: 'Erişim Reddedildi',
    404: 'Bulunamadı',
    409: 'Çakışma',
    422: 'Doğrulama Hatası',
    429: 'Çok Fazla İstek',
    500: 'Sunucu Hatası',
    502: 'Geçersiz Ağ Geçidi',
    503: 'Hizmet Kullanılamıyor',
    504: 'Ağ Geçidi Zaman Aşımı'
  };

  return descriptions[statusCode] || `HTTP ${statusCode}`;
};
